<template>
    <OnlyBar/>
</template>

<script>
// @ is an alias to /src
import OnlyBar from '@/components/OnlyBar.vue'

export default {
  name: 'only-bar',
  components: {
    OnlyBar
  }
}
</script>
